<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title class="info-title" @click="$emit('clicked', index)">
          <font-awesome-icon
            class="collapse"
            :icon="selected ? 'angle-down' : 'angle-left'"
          />
          <div class="text-center text-padding">
            {{ item.StrState }}
          </div>
        </v-card-title>
        <div>
          <app-row icon="book" title="سطح:" :value="item.sath" />
        </div>
        <div v-if="selected">
          <app-row
            icon="hashtag"
            title="شناسه درخواست:"
            :value="item.Fserial"
          />
          <app-row
            icon="calendar-alt"
            title="تاریخ درخواست:"
            :value="item.DDate"
          />
          <app-row
            icon="calendar-alt"
            title="تاریخ صدور مدرک:"
            :value="item.RespDate"
          />
          <div style="padding: 15px">
            <v-row align="center">
              <v-col class="d-flex">
                <b>توضیحات طلبه:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                <span v-html="item.StudentComment"></span>
                <a
                  class="innerLink"
                  v-if="item.HasStudentFile"
                  @click="
                    $emit('callDownload', {
                      index: item.Fserial,
                      step: 0,
                      token: item.HashToken,
                    })
                  "
                  >دریافت پیوست</a
                >
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>موافقت مدرسه:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                {{ item.SchoolState }}.
                <span v-html="item.SchoolComment"></span>
                <a
                  class="innerLink"
                  v-if="item.HasSchoolFile"
                  @click="
                    $emit('callDownload', {
                      index: item.Fserial,
                      step: 1,
                      token: item.HashToken,
                    })
                  "
                  >دریافت پیوست</a
                >
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>پذیرش مدارج:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                {{ item.AmoozeshState }}.
                <span v-html="item.AmoozeshComment"></span>
                <a
                  class="innerLink"
                  v-if="item.HasAmoozeshFile"
                  @click="
                    $emit('callDownload', {
                      index: item.Fserial,
                      step: 2,
                      token: item.HashToken,
                    })
                  "
                  >دریافت پیوست</a
                >
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>موافقت تحقيقات:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                {{ item.TahghighatState }}.
                <span v-html="item.TahghighatComment"></span>
                <a
                  class="innerLink"
                  v-if="item.HasTahgighatFile"
                  @click="
                    $emit('callDownload', {
                      index: item.Fserial,
                      step: 3,
                      token: item.HashToken,
                    })
                  "
                  >دریافت پیوست</a
                >
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>صدور مدرک:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                {{ item.MadarejState }}.
                <span v-html="item.MadarejComment"></span>
                <a
                  class="innerLink"
                  v-if="item.HasMadarejFile"
                  @click="
                    $emit('callDownload', { index: item.Fserial, step: 4 })
                  "
                  >دریافت پیوست</a
                >
              </v-col>
            </v-row>

            <v-row v-if="item.Removeable" class="ltr">
              <v-btn
                color="red white--text"
                class="register"
                rounded
                @click="$emit('removeRequest', item.Fserial)"
              >
                حذف درخواست
              </v-btn>
            </v-row>
            <div style="padding: 5px"></div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["item", "index", "selectedItem"],
  computed: {
    selected() {
      return this.selectedItem == this.index;
    },
    dateRange() {
      return "از " + this.item.AzTarikh + " تا " + this.item.TaTarikh;
    },
  },
  components: {
    appRow: DetailRow,
  },
};
</script>
<style scoped>
.register {
  margin: 20px 20px 0 20px !important;
}
</style>
